import React from 'react';
import { Form } from 'react-bootstrap';

interface InputProps {
  value: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  ref?: React.Ref<HTMLInputElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean; // 省略可（既定: false）
  placeholder?: string; // 省略可（既定: ""）
  className?: string;
  type?: string;
  readonly?: boolean;
}

const Input: React.FC<InputProps> = ({
  value,
  onChange,
  ref,
  onKeyDown,
  disabled = false,
  placeholder = '',
  className = '',
  type = 'text',
  readonly = false,
}) => {
  return (
    <Form.Control
      type={type}
      value={value}
      className={`border-dark ${className}`}
      onChange={onChange}
      ref={ref}
      onKeyDown={onKeyDown}
      disabled={disabled}
      placeholder={placeholder}
      readOnly={readonly}
    />
  );
};

export default Input;
